import { render } from "./chart-js.vue?vue&type=template&id=386ad3d2"
import script from "./chart-js.vue?vue&type=script&lang=js"
export * from "./chart-js.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__